








import {Component, Prop, Vue} from "vue-property-decorator";
import {MqttEndpoint} from "@/types/core-push";

@Component
export default class MqttEndpointView extends Vue {
  @Prop({ default: {},  type: Object}) mqttEndpoint!: MqttEndpoint;
}
